module.exports = __webpack_public_path__ + "img/deckblatt_hintergrundbild.9cc940db.jpg";